import { GraphQLCampaign } from 'modules/campaignIndex/domainTypes';
import { UseCampaignsHasRecentTriggeredAlertsState } from 'modules/campaigns/lib';
import { GRAPHQL_TYPENAMES, GraphQLResponsePaginationInfo } from 'modules/graphql/types';
import { createContext, useContext } from 'react';
import { GraphQLCampaignFolder, GraphQLCampaignSubfolder } from '../../types';

export interface CampaignQueryContextState {
  searchQuery?: string;
  folderData: GraphQLCampaignFolder;
  folderId: number;
  folders: GraphQLCampaignSubfolder[];
  groupRecurringCampaigns: boolean;
  hasResponseError: boolean;
  isLoading: boolean;
  paginationInfo: GraphQLResponsePaginationInfo;
  parentCampaign?: GraphQLCampaign;
  refetch: () => void;
  rootFolderId: number;
  setFolderId: (value: number) => void;
  campaigns: GraphQLCampaign[];
  nbaEnabledCampaignIds: number[];
  campaignTriggeredAlerts?: UseCampaignsHasRecentTriggeredAlertsState['campaignTriggeredAlerts'];
}

export const CampaignQueryContext = createContext<CampaignQueryContextState>({
  folderId: 0,
  rootFolderId: 0,
  groupRecurringCampaigns: false,
  hasResponseError: false,
  setFolderId: () => undefined,
  isLoading: false,
  folders: [],
  campaigns: [],
  folderData: {
    ancestors: [],
    content: [],
    id: 0,
    name: '',
    isFavorite: false,
    __typename: GRAPHQL_TYPENAMES.CAMPAIGN_FOLDER,
  },
  paginationInfo: {
    count: 0,
    limit: 20,
    offset: 0,
    page: 1,
    __typename: GRAPHQL_TYPENAMES.INFO,
  },
  refetch: () => undefined,
  nbaEnabledCampaignIds: [],
  campaignTriggeredAlerts: [],
});

export const useCampaignQueryContext = () => useContext(CampaignQueryContext);
